import React from "react";
import "./DataLoader.scss";
import PropTypes from "prop-types";

const DataLoader = ({ message = "Data Is Loading, Please Wait..." }) => {
  return (
    <div className="loader-section">
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="loader-text">
        <div className="typewriter">{message}</div>
      </div>
    </div>
  );
};

DataLoader.propTypes = {
  message: PropTypes.string,
};

export default DataLoader;
